import axios from "axios";

export const ACTION_GET_CLIENT_PENDING = 'ACTION_GET_CLIENT_PENDING';
export const ACTION_GET_CLIENT_SUCCESS = 'ACTION_GET_CLIENT_SUCCESS';
export const ACTION_GET_CLIENT_ERROR = 'ACTION_GET_CLIENT_ERROR';

function fetchClientPending() {
    return {
        type: ACTION_GET_CLIENT_PENDING
    }
}

function fetchClientSuccess(client) {
    return {
        type: ACTION_GET_CLIENT_SUCCESS,
        client: client
    }
}

function fetchClientError(error) {
    return {
        type: ACTION_GET_CLIENT_ERROR,
        error: error
    }
}

function fetchClientAction(id) {
    axios.defaults.baseURL = window.location.origin;
    var url = '/api/Client/' + id;
    return dispatch => {
        dispatch(fetchClientPending());
        axios.get(url, { withCredentials: true })
            .then(res => res.data)
            .then(res => {
                dispatch(fetchClientSuccess(res));
                return res;
            })
            .catch(error => {
                dispatch(fetchClientError(error));
            })
    }
}

export default fetchClientAction;
